'use strict';

module.exports = {
    init: function () {
        $(document).on('click', '.card-header', function () {
            var $this = $(this);
            var $parent = $this.parent();

            $parent.toggleClass('show');
        });
    },
};
